import React, { useEffect, useState } from 'react'
import { Form, DatePicker, Select, Row, Col, Transfer, Tooltip, Card } from 'antd';
import Input from '../../../ui/Input';
import TextArea from '../../../ui/TextArea';
import { SearchOutlined } from '@ant-design/icons';
import styles from './../../index.module.css';
import PageContainer from '../../../CSIComponents/PageContainer';
import { PROXIMITY_OPTIONS } from '@constants/index'
import { isTagsDisplayed } from '@helpers/FeatureFlags'

const Option = Select.Option;
const dateFormat = 'MM/DD/YYYY';

const AttractionDetailAdd = (props: any) => {
    const [data,setData] = useState<Array<any>>([])

    useEffect(() => {
        setData(props.transferData) 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    const handleChange = (targetKeys:any) => {
        props.setTransferTargetKeys(targetKeys)
    };

    const onSearchChange = (e:any) =>{
        let res = data.filter(item => item.codeName.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1)
        props.setTransferData(res)
    }
    const urlRegex:any = '^((https|http|ftp|rtsp|mms)?://)?(([0-9a-z]+: )?[0-9a-z_!~*\'().&=+$%-]+@)?(([0-9]{1,3}.){3}[0-9]{1,3}|([0-9a-z]+.)+([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].[a-z]{2,6})(:[0-9]{1,4})?((/?)|(/[0-9a-z]+)+/?)$';
    
    return (
        <PageContainer>
        <Card style={{marginTop:-15}}>
        {
            <div>
                <div className={styles.detailViewHead}>
                    <div className={styles.detailViewName}>Attraction</div>
                </div>
                <div className={styles.detailInCon}>
                    <Row gutter={24}>
                        <Col span={6}>
                            <Form.Item label="Name" name="name" rules={[{ required: true, message: 'This field is required' },{ max: 128, message: 'You have reached the max character length of 128' }]}>
                                <Input maxLength={128}/>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="Attraction ID" name="id" rules={[{ max: 32, message: 'You have reached the max character length of 32' }]}>
                                <Input maxLength={32} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="Website URL" name="url" 
                            rules={[{ pattern:urlRegex, message: 'This field should be a URL' }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item
                                name='desc'
                                label="Description"
                                rules={[{ max: 300, message: 'You have reached the max character length of 300' }]}
                            >
                                <TextArea maxLength={300} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col span={6}>
                            <Form.Item label="Type Standard" name="typestandard" rules={[{ required: true, message: 'This field is required' }]}>
                                <Select allowClear onChange={props.changeTypeData}
                                showSearch>
                                    <Option value="Open Travel Standard">Open Travel Standard</Option>
                                    <Option value="Lanyon Attraction Type">Lanyon Attraction Type</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="Type" name="type" rules={[{ required: true, message: 'This field is required' }]}>
                                <Select allowClear showSearch>
                                    {
                                        props.typeData && props.typeData.map((item:any,i:any)=>{
                                            return <Option key={i} value={item.codeName}>{item.codeName}</Option>
                                        })
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="Proximity" name="proximity" rules={[{ required: true, message: 'This field is required' }]}>
                                <Select allowClear defaultValue="" showSearch>
                                    {Object.values(PROXIMITY_OPTIONS).map(
                                        (item: string, index: number) => (
                                            <Option key={index} value={item}>
                                                {item}
                                            </Option>
                                        ),
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item
                                name='typedetail'
                                label="Type Detail"
                                rules={[{ max: 128, message: 'You have reached the max character length of 128' }]}
                            >
                                <TextArea maxLength={128} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={6}>
                            <Form.Item label="Rank" name="rank" rules={[{ pattern: /^[0-9]*[1-9][0-9]*$/, message: 'This field should be a number' }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="Season" name="season" rules={[{ max: 32, message: 'You have reached the max character length of 32' }]}>
                                <Select allowClear showSearch>
                                    <Option value="Winter">Winter</Option>
                                    <Option value="Summer">Summer</Option>
                                    <Option value="YearRound">YearRound</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="Guest Type" name="guesttype" rules={[{ max: 32, message: 'You have reached the max character length of 32' }]}>
                                <Select allowClear showSearch>
                                    <Option value="Family">Family</Option>
                                    <Option value="Adults">Adults</Option>
                                    <Option value="Teens">Teens</Option>
                                    <Option value="Children">Children</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item name='startAndEndDate' label="Start/End Date">
                                <DatePicker.RangePicker  format={dateFormat} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item name='crossstreet' label="Cross Street Name" rules={[{ pattern: /^(.){0,128}$/, message: 'You have reached the max character length of 128' }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    { isTagsDisplayed &&
                        <Row gutter={24} className={styles.pdBottom}>
                            <Col span={12}>
                                <Form.Item name='tags' label="Selected Tags">
                                    <Input onChange={onSearchChange} className={styles.tagsWidth} suffix={
                                        <Tooltip title="search">
                                            <SearchOutlined className={styles.colorOpt} />
                                        </Tooltip>
                                    } />
                                    <Transfer
                                        dataSource={props.transferData}
                                        targetKeys={props.transferTargetKeys}
                                        onChange={handleChange}
                                        render={item => item.codeName}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    }
                </div>        
            </div>
        }
        </Card></PageContainer>
    )
}

export default AttractionDetailAdd;
